import React from 'react';
import { observer } from 'mobx-react-lite';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

interface BaseBackdropLoaderProps {
    isLoading: boolean
}

const BaseBackdropLoader: React.FC<BaseBackdropLoaderProps> = observer(({ isLoading }) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
})

export default BaseBackdropLoader;